module.exports = __webpack_public_path__ + "img/rocket.fe7e3178.svg";